<div class="view-component">
    <div class="view-component-title">
        <span class="title">{{'logintegracao.title'|translateTA}}</span>
    </div>

    <div class="maindiv form-field-density-4">
        <simple-datagrid #dataGridLgt entityName='Mktplgt' parentRow="" [nodata]="true" [condition]="conditionLGT" [getCondition]="getConditionLGTFunction" ></simple-datagrid>
    </div>
    
</div>